import {
  ChangeDetectorRef,
  OnDestroy,
  Pipe,
  PipeTransform
} from "@angular/core";
import { I18NextPipe } from "angular-i18next";

@Pipe({
    name: "i18n",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nPipe implements PipeTransform, OnDestroy {
  constructor(
    private translate: I18NextPipe,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _ref: ChangeDetectorRef
  ) {
    //this.translate = new I18NextPipe(translateSvc);
  }

  private dispose(): void {
    if (typeof this.translate !== "undefined") {
      //this.translate.ngOnDestroy();
    }
  }

  ngOnDestroy(): void {
    this.dispose();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public transform(value: string, ...args: any[]): any {
    return this.translate.transform(value, ...args);
  }
}
